import { IBuyPackageData } from '../../slices/buyPackageModalSlice/types';
import { TAppState } from '../../types';

export const selectBuyPackageModalData = (state: TAppState): IBuyPackageData => {
  return state.buyPackage.data;
};
